import { EChatMemberTypes, EChatMemberUpdateStatus, } from "@rentiohq/shared/dist/types/chat.types";
export { EChatMemberTypes, EChatMemberUpdateStatus, };
export var EChatCustomFilter;
(function (EChatCustomFilter) {
    EChatCustomFilter["Active"] = "ACTIVE";
    EChatCustomFilter["Archived"] = "ARCHIVED";
})(EChatCustomFilter || (EChatCustomFilter = {}));
